import React from "react";
import createReactClass from "create-react-class";
import ReactDOM from "react-dom";
import extend from "lodash/extend";
import Layout from "../components/Layout";
import ActionRoot from "./ActionRoot";
import SessionStore from "shared/models/session/SessionStore";
import MessageStore from "shared/models/session/MessageStore";
import ContentStore from "shared/models/cms/ContentStore";
import RoleStore from "shared/models/session/RoleStore";
import forEach from "lodash/forEach";
import Dispatcher from "util/dispatcher";
import globals from "util/globals";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";


function ValidateUniqueStoreNames(pageStoreClasses, infrastructureStoreClasses) {
    forEach(pageStoreClasses, (Store, key) => {
        const formattedKey = upperFirst(camelCase(key));
        if (infrastructureStoreClasses[formattedKey]) {
            throw new Error(`Store class '${formattedKey}' already exists in infrastructure stores and cannot be overridden`);
        }
    });
}

function instantiatePageStores(pageStoreClasses, props, editable, dispatcher) {
    extend(props, { editable: editable });

    const infrastructureStoreClasses = {
        SessionStore,
        MessageStore,
        RoleStore,
        ContentStore
    };
    const allStoreClasses = {};

    // Validate unique store names
    ValidateUniqueStoreNames(pageStoreClasses, infrastructureStoreClasses);

    extend(allStoreClasses, infrastructureStoreClasses, pageStoreClasses);
    const pageStores = {};
    forEach(allStoreClasses, (Store, key) => {
        const store = new Store(props, dispatcher);
        dispatcher.registerEvents(store);
        pageStores[upperFirst(camelCase(key))] = store;
    });

    return pageStores;
}

const MobxView = (View, pageStoreClasses) => {
    if (typeof window !== "undefined") {
        // Hack for detecting old IE versions. Can't add conditional comments via JSX.
        let div = document.createElement("div");
        div.innerHTML = "<!--[if lte IE 9]><i></i><![endif]-->";
        if (div.getElementsByTagName("i").length === 1) {
            document.body.className += " old-ie";
        }
    }

    // On the client we just want to hook the view up to an existing element, so we create a window.__launcher method,
    // which will be called by a script in Layout.
    if (typeof window !== "undefined") {
        window.__launcher = function(mountId, viewProps, editable) {
            const element = document.getElementById(mountId);
            // For debugging only.
            Object.defineProperty && Object.defineProperty(window, "__model", {
                get() {
                    console.log("Don't use __model in production!");
                    return viewProps;
                }
            });

            // set up globals
            globals.set("environment", viewProps.environment);

            const dispatcher = new Dispatcher();

            // instantiate page stores
            const pageStores = instantiatePageStores(pageStoreClasses, viewProps, editable, dispatcher);

            // Wrap the view so that it has a shared context for the dispatcher and stores to handle actions
            const ContextView = ActionRoot(View, pageStores, editable, dispatcher);

            // render page
            ReactDOM.hydrate(React.createElement(ContextView, { editable: editable }), element);
        };
        // Returning the view is useful for testing purposes.
        return View;
    // On the server we want to render the view inside of Layout.
    } else {
        return createReactClass({
            render() {
                const pageData = extend({}, this.props.data, {
                    content: this.props.content,
                    editable: this.props.editable,
                    environment: this.props.environment
                });

                const dispatcher = new Dispatcher();

                // instantiate page stores
                const pageStores = instantiatePageStores(pageStoreClasses, pageData, this.props.editable, dispatcher);

                // Wrap the view so that it has a shared context for the dispatcher and stores to handle actions
                const ContextView = ActionRoot(View, pageStores, this.props.editable, dispatcher);

                return (
                    <Layout {...this.props} mobx={true}>
                        <ContextView editable={this.props.editable} />
                    </Layout>
                );
            }
        });
    }
};

export default MobxView;
